<template>
	<div>
		<div class="inner with-content top-content email-top">
			<a href="/user/settings#e-mail-skabeloner" class="go-back">
				<SvgIcon icon="arrow-back" />
			</a>

			<div class="headline">
				<h1>{{ $t('mail-template.' + className + '-' + method) }}</h1>
				<p>{{$t('mail-template.edit.headline')}}</p>

				<div class="actions">
					<button class="button transparent" v-on:click="resetTexts()">
						{{$t('button.restore.label')}}
					</button>
					<button class="purple" :disabled="saving" v-on:click="save()">
						{{$t('button.save-template.label')}}
					</button>
				</div>
			</div>
		</div>
		<div class="inner with-content">
			<div class="template-container">
				<template v-for="(template, id) in trigger.templates">
					<template v-if="template">
						<div class="email-template">
							<div>
							<div class="spacing"></div>
							<a href="https://rently.dk/" target="_blank" class="logo">
								<img src="https://www.rently.dk/mediakit/email_logo.png" width="77" height="28">
							</a>

							<div class="container">
								<div class="content">
									<div class="company-logo" v-if="companyLogo">
										<img :src="companyLogo" />
									</div>
									<div class="email-text-editor">
										<div v-html="parsePreview(template.scopeHtmlHeader)"></div>
										<div class="editor-container">
											<div class="purple-badge">
												{{$t('email-template.badge.label')}}
											</div>
											<ckeditor :editor="editor" v-model="template.content" :config="editorConfig"></ckeditor>
										</div>
										<div v-html="parsePreview(template.scopeHtmlFooter)"></div>
									</div>
								</div>
							</div>

							<div class="footer">
								<div class="">
									<span>©{{ new Date().getFullYear() }} Rently</span>
									<span class="seperator">   |   </span>
									<span><a href="https://www.rently.dk/" target="_blank">www.rently.dk</a></span>
									<span class="seperator">   |   </span>
									<span><a href="https://www.rently.dk/om-os" target="_blank">Hvad er Rently?</a></span>
								</div>
								<p>Har du et spørgsmål? Ring til os på +45 71 74 74 23</p>
							</div>
							<div class="spacing"></div>

							</div>
						</div>
					</template>
				</template>
			</div>
		</div>


	</div>
</template>

<script>

	import Vue from 'vue';
	import { mapGetters } from 'vuex';
	import CKEditor from '@ckeditor/ckeditor5-vue';
	import InlineEditor from '@ckeditor/ckeditor5-build-inline';
	import SvgIcon from '../components/Svg.vue';

	Vue.use(CKEditor);

	export default {
		components: {
			SvgIcon
		},
		computed: {
			...mapGetters([
				'getToken',
				'getFullName'
			])
		},
		data: () => ({
			companyLogo: '',
			saving: false,
			className: '',
			method: '',
			editor: InlineEditor,
            editorConfig: {
            	toolbar: []
            },
            trigger: {}
		}),
		methods: {
			resetTexts() {
				for (var i in this.trigger.templates) {
					var template = this.trigger.templates[i];
					if (template) {
						template.content = template.default.html;
					}
				}
			},
			save() {
				this.saving = true;
				axios({
					method: 'PATCH',
					cancelToken: window.AuthorizationCancelSource.token,
                    url: window.config.apiUrl + 'api/email-template/' + this.$route.params.id,
                    data: {
                    	trigger: this.trigger
                    }
				}).then(response => {
					this.$store.commit('setSuccessBarMessage', this.$t('success-message.email.saved'));
				}).finally(e => {
					this.saving = false;
				});
			},
			load() {
				axios({
					method: 'GET',
					cancelToken: window.AuthorizationCancelSource.token,
                    url: window.config.apiUrl + 'api/email-template/' + this.$route.params.id
				}).then(response => {

					this.companyLogo = response.data.companyLogo;

					var templates = response.data.templates;
					for (var i in templates) {
						var template = templates[i];
						if (template) {
							if (!template.content) {
								template.content = template.default.html;
							}
						}
					}
					this.trigger = response.data;
					this.className = response.data.class;
					this.method = response.data.method;
				});
			},
			parsePreview(html) {
				var style = 'max-width: 180px;background-color: #7129e9;color: #ffffff; padding: 18px;margin: 30px auto 0;font-size: 16px;font-weight: 600;border-radius: 4px;display: block;text-align:center;';
				html = html.replace('[[sender.name]]', this.getFullName);
				html = html.replace('[[recipient.name]]', 'Rasmus');
				html = html.replace('[[contract.property]]', 'Eksempelvej 78, 4000 Roskilde');
				html = html.replace(/&lt;btn .*?&gt;(.*?)&lt;\/btn&gt;/mg, '<div style="'+style+'">$1</div>');
				return html;
			}
		},
		created() {
			this.load();
		}
	}
</script>

<style scoped>
	.email-editor-wrapper {
		margin: 30px;
	}
	.email-editor-wrapper h2 {
		margin-bottom: 15px;
	}
	.editor-container {
		width: 600px;
		max-width: 100%;
		padding: 0;
		font-size: 14px;
		border: 1px solid #7129e9;
		border-radius: 2px;
		position: relative;
	}
	.email-text-editor .ck-content {
		outline: none !important;
		box-shadow: none !important;
		border: none !important;
	}
	.ck-toolbar-container .ck.ck-toolbar {
		float: right;
	}
			.email-template {
			font-family: 'HankenGroteskRegular', HelveticaNeue, Helvetica, Arial, sans-serif;
			font-weight: 300;
		    -webkit-font-smoothing: antialiased;
		  background: #e9eef2;
		  width: 100%;
		  text-align: center;
		  display: -webkit-box;
		  display: -ms-flexbox;
		  display: flex;
		  -webkit-box-align: center;
		      -ms-flex-align: center;
		          align-items: center;
		  -webkit-box-pack: center;
		      -ms-flex-pack: center;
		          justify-content: center;
		}
		.email-template .logo {
		    margin-bottom: 25px;
		    display: block;
		}
		.email-template p {
		    color: #808080;
		    font-size: 14px;
		    line-height: 1.5;
		}
		.email-template .container {
		    max-width: 600px;
		    width: 100%;
		    margin: 0 auto;
		    border: 1px solid rgba(0, 0, 0, 0.08);
		    background: #fff;
		}
		.email-template .container .content {
		      padding: 60px;
		}
		.email-template .container .content p {
		        color: #1c073e;
		        font-size: 16px;
		        max-width: 440px;
		        margin: 20px auto;
		        line-height: 2;
		}
		.email-template .container a {
			color: #7129e9;
			font-size: 16px;
			text-decoration: none !important;
		}
		.email-template .container .content .address span {
		          font-size: 20px !important;
		          margin: 0 auto !important;
		          color: #1c073e;
		        max-width: 440px;
		}
		.email-template .container .content .button,
		.email-template .container .content a.purple {
		        padding: 0 30px;
		        margin: 30px auto 0;
	            background-color: #7129e9;
			    color: #ffffff;
			    font-size: 16px;
			    font-family: "HankenGroteskSemiBold", HelveticaNeue, Helvetica, Arial, sans-serif;
			    font-weight: 600;
			    border-radius: 4px;
			    display: block;
			    padding: 18px;
			    width: max-content;
			    max-width: max-content;
			    border: none;
			    text-decoration: none;
			    cursor: pointer;

		}
		.email-template .container .bottom {
		      background: rgba(233, 238, 242, 0.3);
		      border-top: 1px solid rgba(0, 0, 0, 0.08);
		      padding: 30px 60px;
		}
		.email-template .container .bottom p {
			line-height: 1.8;
			margin: 0;
		}
		.email-template .container .bottom a {
			margin-left: 5px;
			font-size: 14px;
			line-height: 1.8;
		}
		.email-template .footer {
		    margin-top: 25px;
		}
		.email-template .footer span {
		      color: #808080;
		      margin: 0 5px;
		      font-family: 'HankenGroteskSemiBold', HelveticaNeue, Helvetica, Arial, sans-serif;
		}
		.email-template .footer span a {
		        color: #808080;
		        text-decoration: none;
		}
		.email-template .footer > div {
		      margin-bottom: 10px;
		}
		.spacing {
			height: 100px;
			width: 100%;
			display: block;
		}

		@media only screen and (max-width: 767px) {
			.email-template .container {
				width: 90%;
				max-width: calc(100% - 340px);
			}
			.email-template .container .content {
				padding: 40px 20px;
			}
			.email-template .container .content p {
				margin: 20px auto 0;
			}
			.email-template .container .bottom {
				padding: 20px;
			}
			.email-template .footer span {
				font-size: 16px;
				display: block;
			}
			.email-template .footer span.seperator {
				opacity: 0;
			}
			.spacing {
				height: 40px;
			}
			.email-template .footer p {
			    max-width: 250px;
			    margin: 10px auto;
			    font-size: 16px;
			}
			.email-template .footer a {
			    font-size: 16px;
			    color: #7129e9;
			    text-decoration: none !important;
			}
		}
</style>
